export default "__VITE_ASSET__072ddbd9__"